<template>
  <div class="item-card">
    <div class="type">
      <div class="f align-center">
        <VueIcon class="sign" icon="jam:chronometer" width="22px" color="white"></VueIcon>
        <span>{{ timeLeft }}</span>
      </div>
      <div class="gw-type type-color">{{ item.giveaway_type }}</div>
    </div>

    <!-- Item Image -->
    <div class="item-image">
      <img :src="item?.item_detail.image" :alt="item?.item_detail.short_name" />
    </div>

    <!-- Item Name -->
    <div class="item-name">
      <h5>{{ item?.item_detail.short_name }}</h5>
      <p>{{ item?.item_detail.exterior }}</p>
    </div>

    <!-- Price -->
    <div class="f flex-column align-center">
      <div class="item-price">
        <span>${{ formatPrice() }}</span>
      </div>
    </div>

    <!-- Total Entries -->
    <div class="item-entries">
      <span>{{ item.total_entries }} users joined</span>
    </div>

    <!-- Action Buttons --> 
    <div class="action-buttons">
      <button v-if="isUserAuthenticated && !item.joined && !item.can_join" class="join-button" :disabled="true">
        Complete Tasks
      </button>
      <button v-else-if="isUserAuthenticated && !item.joined && item.can_join" @click="joinGiveaway" class="join-button">
        {{ buttonText }}
      </button>
      <button v-else-if="isUserAuthenticated && item.joined" class="join-button" disabled>
        Already Joined
      </button>
      <button v-else @click="signIn" class="join-button">
        {{ buttonText }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    buttonText: {
      type: String,
      required: true,
    },
    isButtonDisabled: {
      type: Boolean,
      required: true,
      default: false
    },
    isUserAuthenticated: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      timeLeft: "",
      timerInterval: null,
    };
  },
  created() {
    this.updateTimeLeft();
    this.timerInterval = setInterval(this.updateTimeLeft, 1000);
  },
  beforeUnmount() {
    clearInterval(this.timerInterval);
  },
  methods: {
    updateTimeLeft() {
      const giveawayStartDate = new Date(this.item.expires_at);
      const now = new Date();
      const timeDiff = giveawayStartDate - now;

      if (timeDiff <= 0) {
        this.timeLeft = "Giveaway başladı!";
        clearInterval(this.timerInterval);
        return;
      }

      const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

      this.timeLeft = `${days}d ${hours}h ${minutes}m ${seconds}s`;
    },
    formatPrice() {
      return (this.item?.item_detail?.price_info[0]?.price / 1000)
        .toFixed(2).toLocaleString("en-US");
    },
    joinGiveaway() {
      this.$emit('join-giveaway', this.item.id);
    },
    signIn() {
      this.$emit('sign-in');
    },
  },
};
</script>

<style scoped>
.type {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  padding: 5px 5px;
}

.item-card {
  position: relative;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  width: 240px;
  min-height: 350px;
  text-align: center;
  padding: 10px;
  background: #00000063;
  border: 1px solid transparent;
}

.item-card:hover .item-image img {
  transform: scale(1.05);
  transition: 0.1s;
}

.item-card:not(hover) .item-image img {
  transform: scale(1);
  transition: 0.1s;
}

.gw-type {
  align-items: center;
  border: 1px solid;
  border-radius: 0.2rem;
  color: #fff;
  display: flex;
  font-size: 0.75rem;
  font-weight: 700;
  gap: 10px;
  height: auto;
  padding: 4px 5px;
  position: relative;
}

.type span {
  font-size: 12px;
}

.price-div {
  background-color: #4622f91f;
  padding: 0.5rem;
}

.type-color {
  background-color: rgba(172, 229, 74, 0.1);
  border-color: rgba(172, 229, 74, 0.75);
}

.time-left {
  color: purple;
  padding: 10px;
  border-radius: 5px;
  font-weight: bold;
  font-size: 1.2em;
}

.item-image img {
  width: 9rem;
  object-fit: cover;
}

.item-name {
  margin-top: 5px;
}

.item-name h5 {
  font-size: 16px;
  font-weight: bold;
  color: white;
}

.item-price {
  background-color: #313156;
  padding: 0.2rem 0.4rem;
  color: white;
  border-radius: 3px;
}

.item-price span {
  font-size: 12px;
}

p {
  font-size: 13px;
  color: white;
}

.item-entries {
  margin-top: 10px;
}

.item-entries span {
  color: #9795b3;
}

.action-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.join-button {
  background-image: linear-gradient(to right,
      #954ce9 0%,
      #7d32d2 51%,
      #5b28f3 100%);
  background-size: 200% auto;
  background-position: left center;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  width: 100%;
  transition: background-position 0.2s ease;
}

.join-button:hover {
  background-position: right center;
}
</style>
